<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500"
      >
        List of Uploaded Files
      </div>
      <v-spacer></v-spacer>
      <v-col
        class="mt-0 pt-0 pb-0 mb-0 text-end custom"
        v-if="
          this.propName == 'sku_mapping' ||
          this.propName == 'sku_sync' ||
          this.type == 'sku_mapping' ||
          this.type == 'sku_sync'
        "
      >
        <v-autocomplete
          v-model="type"
          :items="types"
          @input="fetchOrderList"
          label="Type"
          item-text="text"
          class="mt-0 pt-0 pb-0 mb-0"
          item-value="value"
        ></v-autocomplete>
      </v-col>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="_headers"
      :items="orderList"
      :options.sync="options"
      :server-items-length="total"
      :loading="orderListLoader"
      class="elevation-1 custom-icon-size"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.modified`]="{ item }">
        {{ item.modified | uaeDateTime | moment("DD MMM, YYYY hh:mm A") }}
      </template>
      <template v-slot:[`item.duty_handling`]="{ item }">
        {{ item.duty_handling ? item.duty_handling.toUpperCase() : "" }}
      </template>

      <template v-slot:[`item.upload_type`]="{ item }">
        {{
          item.upload_type === "order_upload"
            ? "Fulfillment Order"
            : item.upload_type === "product_upload"
            ? "Fulfillment Products/ SKU"
            : item.upload_type === "create_order"
            ? "Lastmile Manifest / Create Package"
            : item.upload_type === "sku_sync"
            ? "Sku Sync"
            : item.upload_type === "sku_mapping"
            ? "Sku Mapping"
            : item.upload_type === "package_upload"
            ? "Lastmile Package Upload"
            : item.upload_type === "channel_sku_mapping_upload"
            ? "Channel Sku Mapping"
            : item.upload_type === "inbound_upload"
            ? "Inbound Upload"
            : item.upload_type === "outbound_upload"
            ? "Outbound Upload"
            : item.upload_type === "b2b_sku_upload"
            ? "B2B SKU Upload"
            : item.upload_type === "inbound_variant_upload"
            ? "Inbound Variant Upload"
            : item.upload_type === "outbound_variant_upload"
            ? "Outbound Variant Upload"
            : item.upload_type === "inbound_bulk_upload"
            ? "Inbound Bulk Upload"
            : item.upload_type === "outbound_bulk_upload"
            ? "Outbound Bulk Upload"
            : item.upload_type === "sku_barcode_upload"
            ? "SKU Barcode Upload"
            : ""
        }}
      </template>
      <template v-slot:[`item.created`]="{ item }">
        {{ item.created | uaeDateTime | moment("DD MMM, YYYY hh:mm A") }}
      </template>
      <template v-slot:[`item.excel_file_complete`]="{ item }">
        <v-icon
          @click="download(item.excel_file_complete)"
          small
          v-if="
            item.status !== 'Pending' &&
            item.status !== 'In Processing' &&
            item.status !== 'Failed'
          "
        >
          mdi-file
        </v-icon>
      </template>
      <template v-slot:[`item.excel_file_uploaded`]="{ item }">
        <v-icon
          @click="download(item.excel_file_uploaded)"
          small
          v-if="item.excel_file_uploaded !== null"
        >
          mdi-file
        </v-icon>
      </template>

      <template
        v-slot:[`item.failed_count`]="{ item }"
        v-if="propName == 'inbound_upload' || propName == 'outbound_upload'"
      >
        <a @click="openFailedCount(item)" v-if="item.failed_count > 0">{{
          item.failed_count
        }}</a>
        <span v-else>{{ item.failed_count }}</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <a
          @click="open(item)"
          v-if="
            item.message !== null &&
            item.status !== 'Failed' &&
            item.status !== 'Pending' &&
            item.upload_type !== 'inbound_upload' &&
            item.upload_type !== 'outbound_upload' &&
            item.upload_type !== 'inbound_variant_upload' &&
            item.upload_type !== 'outbound_variant_upload' &&
            item.upload_type !== 'inbound_bulk_upload' &&
            item.upload_type !== 'outbound_bulk_upload' &&
            item.status !== 'Processed' &&
            item.status !== 'In Processing'
          "
          >{{ item.status }}</a
        >
        <span
          v-else-if="
            propName == 'inbound_upload' ||
            propName == 'outbound_upload' ||
            propName == 'inbound_variant_upload' ||
            propName == 'outbound_variant_upload' ||
            propName == 'inbound_upload,inbound_bulk_upload' ||
            propName == 'outbound_bulk_upload' ||
            propName == 'outbound_upload,outbound_bulk_upload' ||
            propName == 'inbound_bulk_upload'
          "
        >
          <a
            @click="open(item)"
            v-if="
              item.status !== 'In Processing' && item.status !== 'Processed'
            "
            >{{ item.status }}</a
          >
          <span v-else>{{ item.status }}</span>
        </span>

        <span v-else>{{ item.status }}</span>

        <v-tooltip
          bottom
          v-if="
            item.try_flag == true &&
            checkPermission('app_ecom_vendors:fulfillment_manual_excel_trigger')
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="handleClick(item)"
            >
              <template> mdi-update </template>
            </v-icon>
          </template>
          <span>Try Again</span>
        </v-tooltip>

        <br />
        <v-tooltip bottom v-if="item.upload_type == 'product_upload'">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              <span v-if="item.success_count > 0">Status: Completed</span>

              <span v-else-if="item.total_count - item.error_count > 0">
                Status: In Progress</span
              >
            </span>
          </template>
          <span
            ><small> Sync Initiated: {{ item.updated_count }}</small
            ><br />
            <small> Sync Success: {{ item.success_count }}</small
            ><br /><small> Sync Failed: {{ item.failed_count }} </small><br />
          </span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="syncMessage"
      max-width="650px"
      scrollable
      close-delay="ma-5"
      @keydown.esc="
        syncMessage = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              syncMessage = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="details"
            :items="detailsData"
            class="elevation-1 mt-7"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :items-per-page="25"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="propName == 'product_upload'"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    {{ item }}
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="openMessage"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessage = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessage = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="_detailsHeaders"
            :items="detailsData"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.ordercode`]="{ item }"
              v-if="propName == 'package_upload'"
            >
              {{ item.order_reference }}
            </template>
            <template
              v-slot:[`item.tracking_no`]="{ item }"
              v-if="propName == 'package_upload'"
            >
              {{ item.message.tracking_no }}
            </template>
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="propName == 'package_upload'"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    {{ item }}
                  </li>
                </ul>
              </span>
            </template>
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="propName == 'order_upload'"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item.message }}</b>
                    <br />{{ item.description }}
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openMessageInbound"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessageInbound = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessageInbound = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="inboundHeaders"
            :items="newArray"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="newArray !== null"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item }}</b>
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openMessageInboundBulk"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessageInboundBulk = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessageInboundBulk = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="inboundHeadersBulk"
            :items="newArray"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="newArray !== null"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item }}</b>
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openMessageOutboundBulk"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessageOutboundBulk = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessageOutboundBulk = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="outboundHeadersBulk"
            :items="newArray"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="newArray !== null"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item }}</b>
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openMessageVariant"
      max-width="750px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessageVariant = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessageVariant = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="variantHeaders"
            :items="newArray"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="newArray !== null"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item }}</b>
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openMessageVariantOutbound"
      max-width="750px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessageVariantOutbound = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessageVariantOutbound = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="failedoutboundHeaders"
            :items="newArray"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="newArray !== null"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item }}</b>
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="openMessageProduct"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openMessageProduct = false;
        detailsData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon
            @click="
              openMessageProduct = false;
              detailsData = [];
            "
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="productHeaders"
            :items="detailsData"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
            <template
              v-slot:[`item.errors`]="{ item }"
              v-if="detailsData !== null"
            >
              <span v-if="item.errors !== null">
                <ul v-if="item.errors.length > 0">
                  <li v-for="(item, i) of item.errors" :key="i">
                    <b>{{ item.message }}</b>
                    <br />{{ item.description }}
                  </li>
                </ul>
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="failedCountPopUp"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        failedCountPopUp = false;
        failedData = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon @click="failedCountPopUp = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="failedHeaders"
            :items="failedData"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetailsFailed"
            :server-items-length="failedtotals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="openSkuBarcode"
      max-width="650px"
      close-delay="ma-5"
      scrollable
      @keydown.esc="
        openSkuBarcode = false;
        skuArray = [];
      "
    >
      <v-card>
        <v-card-title
          >Message
          <v-spacer></v-spacer>
          <v-icon @click="openSkuBarcode = false">mdi-close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-data-table
            :headers="barcodeHeaders"
            :items="skuArray"
            class="elevation-1 mt-7"
            :items-per-page="25"
            :options.sync="optionsDetails"
            :server-items-length="totals"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 100, 250],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="loader-wrapper" v-if="isloading">
      <div class="loader"></div>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},

  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    _headers() {
      return this.headers.filter((i) => {
        if (this.type == "sku_sync") {
          return (
            i.value !== "duty_handling" &&
            i.value !== "delivery_type" &&
            i.value !== "excel_file_uploaded" &&
            i.value !== "failed_count" &&
            i.value !== "success_count" &&
            i.value !== "updated_count" &&
            i.value !== "total_count"
          );
        } else if (
          this.propName == "inbound_upload" ||
          this.propName == "outbound_upload" ||
          this.propName == "b2b_sku_upload" ||
          this.propName == "inbound_variant_upload" ||
          this.propName == "outbound_variant_upload" ||
          this.propName == "inbound_upload,inbound_bulk_upload" ||
          this.propName == "outbound_bulk_upload" ||
          this.propName == "outbound_upload,outbound_bulk_upload" ||
          this.propName == "sku_barcode_upload"
        ) {
          return i.value !== "duty_handling" && i.value !== "delivery_type";
        } else {
          if (this.propName == "package_upload") {
            return (
              i.value !== "failed_count" &&
              i.value !== "success_count" &&
              i.value !== "updated_count" &&
              i.value !== "total_count"
            );
          } else {
            return (
              i.value !== "duty_handling" &&
              i.value !== "delivery_type" &&
              i.value !== "failed_count" &&
              i.value !== "success_count" &&
              i.value !== "updated_count" &&
              i.value !== "total_count"
            );
          }
        }
      });
    },
    _detailsHeaders() {
      return this.detailsHeaders.filter((i) =>
        this.propName !== "package_upload" ? i.value !== "tracking_no" : true
      );
    },
  },
  props: {
    propName: String, // Declare the prop with its expected type
  },
  data: () => ({
    openMessageInboundBulk: false,
    openMessageOutboundBulk: false,
    isloading: false,
    failedCountPopUp: false,
    failedData: [],
    productsData: [],
    openMessageProduct: false,
    types: [
      { text: "Sku Mapping", value: "sku_mapping" },
      { text: "Sku Sync List", value: "sku_sync" },
    ],
    type: null,
    totals: 0,
    failedtotals: 0,
    optionsDetailsFailed: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    optionsDetails: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    syncMessage: false,
    openMessage: false,
    openMessageInbound: false,
    openMessageVariant: false,
    openMessageVariantOutbound: false,
    detailsHeaders: [
      {
        text: "Order #",
        value: "ordercode",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Tracking No.",
        value: "tracking_no",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Warning",
        value: "warnings",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Result",
        value: "result",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    failedHeaders: [
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Error Reason",
        value: "error_reason",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    failedoutboundHeaders: [
      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    productHeaders: [
      {
        text: "Product id",
        value: "product_id",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Result",
        value: "result",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    variantHeaders: [
      {
        text: "Variant SKU",
        value: "variant_sku_code",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "LPN Number",
        value: "lpn_number",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    inboundHeaders: [
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Unique Line",
        value: "unique_line",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    inboundHeadersBulk: [
      {
        text: "Receipt No.",
        value: "receipt_no",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Unique Line",
        value: "unique_line",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    outboundHeadersBulk: [
      {
        text: "Order No.",
        value: "order_number",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Unique Line",
        value: "unique_line",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    details: [
      {
        text: "Code",
        value: "product_code",
        class: "body-1 font-weight-bold",
        align: "left",
      },
      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
      },
      {
        text: "Warning",
        value: "warnings",
        class: "body-1 font-weight-bold",
        align: "left",
      },
      {
        text: "Result",
        value: "result",
        class: "body-1 font-weight-bold",
        align: "left",
      },
    ],
    headers: [
      {
        text: "Client Name",
        value: "client_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Type of Upload",
        value: "upload_type",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Uploaded By",
        value: "upload_by",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Created At",
        value: "created",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Uploaded File",
        value: "excel_file_uploaded",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Total Count",
        value: "total_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Processed Count",
        value: "updated_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Failed Count",
        value: "failed_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Success Count",
        value: "success_count",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Delivery Type",
        value: "delivery_type",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Duty Handling",
        value: "duty_handling",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Processed Date",
        value: "modified",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    options: {},
    total: 0,
    orderList: [],
    orderListLoader: false,
    detailsData: [],
    dropdownSelected: false,
    newArray: [],
    previousNumber: 25,
    loadingItems: {},
    newArrayBulk: [],
    openSkuBarcode: false,
    barcodeHeaders: [
      {
        text: "B2B SKU",
        value: "b2b_sku_id",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Barcode",
        value: "barcode",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Error",
        value: "errors",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Message",
        value: "message",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
    ],
    skuArray: [],
  }),

  watch: {
    options: {
      handler() {
        if (this.propName !== "sku_sync" && this.propName !== "sku_mapping") {
          this.fetchOrderList();
        }
        if (this.dropdownSelected == true) {
          this.fetchOrderList();
        }
      },
      deep: true,
    },

    optionsDetails: {
      handler() {
        this.open(this.item);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getOrderList",
      "downloadOrderFile",
      "getMessageRes",
      "manualTriger",
      "snackBar",
      "getOrderListBulk",
    ]),
    async openFailedCount(item) {
      this.faileditem = item;
      this.failedData = [];
      var type;
      if (this.propName == "inbound_upload") {
        type = "inbound";
      } else if (this.propName == "outbound_upload") {
        type = "outbound";
      } else if (this.propName == "inbound_variant_upload") {
        type = "inbound_variant_upload";
      } else if (this.propName == "outbound_variant_upload") {
        type = "outbound_variant_upload";
      }

      let data = {
        excel_id: this.faileditem.id,
        b2b_upload: type,
      };
      await this.getMessageRes({ ...data, ...this.optionsDetailsFailed }).then(
        (res) => {
          this.failedData = res.data.records;

          this.failedtotals = res.data.total;
          this.failedCountPopUp = true;
          if (this.failedData == null || this.failedData == undefined) {
            this.failedData = [];
          }
        }
      );
    },
    async open(item) {
      this.detailsData = [];
      this.item = item;
      if (this.item == undefined) return;

      if (this.propName == "package_upload") {
        window.open(
          this.$router.resolve({
            name: "PackageErrorlist",
            query: {
              excel_id: this.item.id,
            },
          }).href,
          "_blank"
        );
      } else if (
        this.item.upload_type == "outbound_bulk_upload" ||
        this.item.upload_type == "inbound_bulk_upload"
      ) {
        window.open(
          this.$router.resolve({
            name: "OutboundErrorlist",
            query: {
              excel_id: this.item.id,
              name: this.item.upload_type,
            },
          }).href,
          "_blank"
        );
      } else if (
        this.item.upload_type == "inbound_upload" ||
        this.item.upload_type == "outbound_upload"
      ) {
        window.open(
          this.$router.resolve({
            name: "InboundErrorlist",
            query: {
              excel_id: this.item.id,
              name: this.item.upload_type,
            },
          }).href,
          "_blank"
        );
      } else if (this.propName == "sku_barcode_upload") {
        window.open(
          this.$router.resolve({
            name: "BarcodeErrorlist",
            query: {
              excel_id: this.item.id,
            },
          }).href,
          "_blank"
        );
      } else {
        let data = {
          excel_id: this.item.id,
        };
        await this.getMessageRes({ ...data, ...this.optionsDetails }).then(
          (res) => {
            this.detailsData = res.data.records;
            if (this.detailsData == null || this.detailsData == undefined) {
              this.detailsData = [];
            }
            this.totals = res.data.total;
          }
        );
        if (
          this.propName == "product_upload" ||
          this.propName == "sku_mapping"
        ) {
          this.syncMessage = true;
        } else if (this.propName == "sku_sync") {
          this.openMessage = true;
        } else if (this.propName == "channel_sku_mapping_upload") {
          this.openMessageProduct = true;
        } else if (
          this.propName == "inbound_variant_upload" ||
          this.propName == "outbound_variant_upload"
        ) {
          this.newArray = [];
          this.newArray = this.detailsData;

          if (this.propName == "inbound_variant_upload") {
            this.openMessageVariant = true;
          } else if (
            this.propName == "inbound_upload" ||
            this.propName == "outbound_upload" ||
            this.item.upload_type == "outbound_upload" ||
            this.item.upload_type == "inbound_upload"
          ) {
            this.openMessageInbound = true;
          } else if (this.propName == "outbound_variant_upload") {
            this.openMessageVariantOutbound = true;
          }
        } else if (this.propName == "sku_barcode_upload") {
          this.openSkuBarcode = true;
          this.newArray = [];
          this.newArray = this.detailsData;
        } else {
          this.openMessage = true;
        }
      }
    },
    async handleClick(item) {
      this.isloading = true;
      this.$set(this.loadingItems, item.id, true); // Set loading state for the specific item
      try {
        await this.tryAgain(item); // Assume this is an async function
      } finally {
        this.$set(this.loadingItems, item.id, false); // Reset loading state for the item
      }
    },
    async tryAgain(item) {
      let data = {
        excel_id: item.id,
      };
      await this.manualTriger(data).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data.data.message,
        });
        this.isloading = false;

        this.fetchOrderList();
      });
    },
    fetchOrderList() {
      if (this.type !== null) {
        this.propName = this.type;
        this.dropdownSelected = true;
      }
      this.orderList = [];
      this.orderListLoader = true;

      if (
        this.propName == "inbound_upload,inbound_bulk_upload" ||
        this.propName == "outbound_bulk_upload" ||
        this.propName == "outbound_upload,outbound_bulk_upload"
      ) {
        this.getOrderListBulk({
          ...this.options,
          ...this.filtersArr,
          type: this.propName,
        })
          .then((res) => {
            this.orderListLoader = false;
            this.orderList = res.data.records;
            this.total = res.data.total;
          })
          .catch(() => {
            this.orderListLoader = false;
          });
      } else {
        this.getOrderList({
          ...this.options,
          ...this.filtersArr,
          type: this.propName,
        })
          .then((res) => {
            this.orderListLoader = false;
            this.orderList = res.data.records;
            this.total = res.data.total;
          })
          .catch(() => {
            this.orderListLoader = false;
          });
      }
    },
    download(url) {
      // if (
      //   this.propName == "product_upload" ||
      //   this.propName == "channel_sku_mapping_upload" ||
      //   this.propName == "sku_mapping"
      // ) {
      //   url = `/api/file_download?file_path=${url}`;
      // }
      url = `/api/file_download?file_path=${url}`;

      this.downloadOrderFile(url)
        .then((res) => {
          this.fileDownload(res);
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.custom .v-text-field__details {
  display: none;
}
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure the loader appears on top of other content */
}
.loader-wrapper.active {
  display: flex;
}

.content {
  display: none;
}

.loader-wrapper.active + .content {
  display: block;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Add a spinning animation */
}
/* Animation keyframes for the loader */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
